/**
 * Centralized API URL configuration.
 *
 * Development: relative paths proxied by Vite dev server.
 * Production: unified api.puglieseweb.com domain with per-service path prefixes.
 */

const isDev = import.meta.env.DEV;

/** SystemDox product API — GitHub connector, doc indexing, specs, graph, staleness, backlog. */
export const SYSTEMDOX_API_URL = isDev
  ? '/api'
  : `${import.meta.env.REACT_APP_API_BASE_URL || ''}/systemdox/v1`;

/** Docs platform API — generic document primitives (shared-docsplatform). */
export const DOCS_API_URL = isDev
  ? '/docs-api'
  : `${import.meta.env.REACT_APP_API_BASE_URL || ''}/docs/v1`;

/** Shared-auth API (email verification). */
export const AUTH_API_URL = isDev
  ? '/auth-api'
  : `${import.meta.env.REACT_APP_API_BASE_URL || ''}/auth/v1`;

/** Shared user-profile API — cross-product avatars. */
export const PROFILE_API_URL = isDev
  ? '/profile-api'
  : `${import.meta.env.REACT_APP_API_BASE_URL || ''}/profile/v1`;
